import React, { useContext, useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { MenuItem } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { getDatabase, ref, get } from 'firebase/database';
import CrudContext from './crud-context';
import AppContext from '../app-context';
import dayjs from 'dayjs';

export const ILookup = ({ fieldInfo }) => {
    const [hasAccess, setHasAccess] = useState(true);
    const {
        setFormState,
        formState
    } = useContext(CrudContext);
    const {
        accessLevel
    } = useContext(AppContext);
    const {
        label,
        lookupKey,
        lookupItemKeyFn,
        lookupItemValueFn,
        name
    } = fieldInfo;
    const [options, setOptions] = useState([]);

    useEffect(() => {
        // not watching? should, though.
        get(ref(getDatabase(), `/${lookupKey}`))
            .then((snapshot) => {
                const payload = snapshot.val();
                const itemKeys = Object.keys(payload);
                const items = itemKeys.map((i) => ({
                    id: i,
                    ...payload[i]
                }));
                
                const newOptions = items.map((i) => ({
                    key: lookupItemKeyFn(i),
                    value: lookupItemValueFn(i)
                }));
                setOptions(newOptions);
                setHasAccess(true);
            })
            .catch(() => {
                setHasAccess(false);
            });
        // let newRef = firebase.database().ref(`/${lookupKey}`);
        // newRef.onDisconnect().cancel();
        // newRef.once('value')
        //     .then((snapshot) => {
        //         const payload = snapshot.val();
        //         const itemKeys = Object.keys(payload);
        //         const items = itemKeys.map((i) => ({
        //             id: i,
        //             ...payload[i]
        //         }));
                
        //         const newOptions = items.map((i) => ({
        //             key: lookupItemKeyFn(i),
        //             value: lookupItemValueFn(i)
        //         }));
        //         setOptions(newOptions);
        //         setHasAccess(true);
        //     })
        //     .catch(() => {
        //         setHasAccess(false);
        //      });
        // return () => newRef.off();
    }, [lookupKey, lookupItemKeyFn, lookupItemValueFn, accessLevel]);

    function updateState({ target }) {
        setFormState({ [name]: target.value });
    }

    const hasValueAndOptionsNotLoaded = options.length === 0 && formState[name];
    const optionSet = hasValueAndOptionsNotLoaded ? [{ key: formState[name], value: formState[name] }] : options;

    if (!hasAccess) {
        return (<div>ACCESS ERROR</div>);
    }
    return (<FormControl>
        <InputLabel>{ label }</InputLabel>
        <Select
            onChange={ updateState }
            value={ formState[name] || '' }
            style={{ minWidth: 800 }}
        >
            { optionSet.map((o) => (
                <MenuItem key={ o.key } value={ o.key }>
                    { o.value }
                </MenuItem>
            ))}
        </Select>
    </FormControl>);
};

export const DateField = ({ fieldInfo, style }) => {
    const {
        setFormState,
        formState
    } = useContext(CrudContext);
    const {
        label,
        name
    } = fieldInfo;

    function updateState(newValue) {
        // Store as ISO string with time (e.g., "YYYY-MM-DDTHH:mm")
        setFormState({ [name]: newValue ? newValue.format('YYYY-MM-DDTHH:mm') : '' });
    }

    return (<DateTimePicker
        label={ label }
        value={ formState[name] ? dayjs(formState[name]) : null }
        onChange={ updateState }
        textField={(params) => <TextField {...params} style={ style } />}
    />);
};

export const Text = ({ fieldInfo, style }) => {
    const {
        setFormState,
        formState
    } = useContext(CrudContext);
    const {
        label,
        name
    } = fieldInfo;

    function updateState({ target }) {
        setFormState({ [name]: target.value });
    }

    return (<TextField
        label={ label }
        value={ formState[name] || '' }
        onChange={ updateState }
        style={  style }
    />);
};

export const Textarea = ({ fieldInfo, style }) => {
    const {
        setFormState,
        formState
    } = useContext(CrudContext);
    const {
        label,
        name
    } = fieldInfo;

    function updateState({ target }) {
        setFormState({ [name]: target.value });
    }

    return (<TextField
        style={  style }
        multiline
        minRows={ 3 }
        maxRows={20}
        label={ label }
        value={ formState[name] || '' }
        onChange={ updateState }
    />);
};



export const Number = ({ fieldInfo, style }) => {
    const {
        setFormState,
        formState
    } = useContext(CrudContext);
    const {
        label,
        name
    } = fieldInfo;

    function updateState({ target }) {
        setFormState({ [name]: target.value });
    }

    return (<TextField
        type="number"
        label={ label }
        style={  style }
        value={ formState[name] || '' }
        onChange={ updateState }
    />);
};

export const SelectOne = ({ fieldInfo, style }) => {
    const {
        setFormState,
        formState
    } = useContext(CrudContext);
    const {
        label,
        options = [],
        name
    } = fieldInfo;

    function updateState({ target }) {
        setFormState({ [name]: target.value });
    }

    return (<FormControl>
        <InputLabel>{ label }</InputLabel>
        <Select
            onChange={ updateState }
            value={ formState[name] || '' }
            style={{ minWidth: 800, ...style }}
        >
            { options.map((o) => (
                <MenuItem key={ o.key } value={ o.key }>
                    { o.value }
                </MenuItem>
            ))}
        </Select>
    </FormControl>);
};
